import React from 'react';

class Header extends React.Component{

    render() {
        const logoutButton = <button className="btn btn-primary btn-right" onClick={this.props.logout}>Log out</button>;

        return (
            <div className="header flex-between">
                <img alt="Intuitive Sensitives" src="images/logo.svg" />
                {this.props.auth !== null ? logoutButton : null}
            </div>
        );
    }
}

export default Header;


/** WEBPACK FOOTER **
 ** ./src/components/ui/Header.js
 **/